/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type {
  TaskRecordList,
  ActivityList,
  ActivityPeopleList,
  AuditRecordList,
  AddTaskNumList,
  SummaryList
} from './types';

enum Api {
  taskRecordList = '/front-end/task/api/v1/taskRecordList', // 任务记录列表
  quickAuditList = '/front-end/quickAudit/api/v1/taskList', // 快捷审核--任务列表
  batchAudit = '/front-end/task/api/v1/batchAudit', // 任务记录---批量审核
  batchOverdue = '/front-end/task/api/v1/batchOverdue', // 任务记录---批量过期
  getOverdue = '/front-end/task/api/v1/overdue/taskRecordIds', // 任务记录集合下 筛选出符合能够过期的ID集合
  getDisplayInfo = '/front-end/quickAudit/api/v1/getDisplayInfo', // 获取展示信息
  projectInfo = '/front-end/task/api/v1/projectInfo', //项目ID对应的项目信息
  quickReplyList = '/front-end/quickAudit/api/v1/quickReplyList', // 快捷回复---快捷批注内容列表
  deleteQuickReply = '/front-end/quickAudit/api/v1/deleteQuickReply', // 快捷回复---删除快捷批注内容
  taskRecordDetail = '/front-end/task/api/v1/taskRecordDetail', // 获取任务记录详情 返回详情
  auditRecordList = '/front-end/task/api/v1/auditRecordList', // 任务记录---审核记录（分页）
  setExcessAudit = '/front-end/task/api/v1/setExcessAudit', // 超量审核开关
  selectMonthTask = '/front-end/task/api/v1/selectMonthTask', //数字专区 - 获取月任务详情
  updatePrice = '/front-end/agreementServiceUser/api/v1/settlementAmount/update', // 【数字专区】- 修改结算金额
  addTaskNumList = '/front-end/agreementServiceUser/api/v1/taskRecord/userList', //任务记录 - 协定服务 - 添加任务量列表
  addTaskNum = '/front-end/agreementServiceUser/api/v1/taskRecord/addTaskNum', //任务记录 - 协定服务 - 添加任务量
  importSettlementAmount = '/front-end/agreementServiceUser/api/v1/settlementAmount/import', //任务记录 - 协定服务 - 导入结算金额
  downloadTask = '/front-end/agreementServiceUser/api/v1/taskRecord/download', //任务记录 - 协定服务 - 下载列表数据
  uploadTaskFile = '/front-end/agreementServiceUser/api/v1/taskRecord/submitUploadFile', //任务记录 - 协定服务 - 上传附件
  getTaskFile = '/front-end/agreementServiceUser/api/v1/taskRecord/getFile', //任务记录 - 协定服务 - 查看附件信息
  submitTask = '/front-end/agreementServiceUser/api/v1/taskRecord/submit', //任务记录 - 协定服务 - 提交
  userTags = '/front-end/task/api/v1/userTags', //项目ID对应的人员标签 列表
  taskRecordPassIds = '/front-end/task/api/v1/taskRecordPassIds', //任务记录集合下 筛选出符合能够通过的ID集合

  taskRecordUpdateMap = '/front-end/task/api/v1/taskRecordUpdateMap', //任务记录---更新地图
  locationMapComparison = '/front-end/task/api/v1/locationMapComparison', //任务记录---对比地图
  taskRecordStats = '/front-end/task/api/v1/taskRecordStats', // 任务记录-统计信息
  taskRecordIdsByQuick = '/front-end/quickAudit/api/v1/taskIdList', //快捷审核 - 任务ID集合
  taskRecordIds = '/front-end/task/api/v1/taskRecordIds', //任务记录 - 任务ID集合

  activityList = '/front-end/api/v1/agreementService/activity/list/activity/asp', // 获取活动列表
  createactivity = '/front-end/api/v1/agreementService/activity/create/activity', // 【协定服务活动】- 创建协定服务活动
  updateActivityName = '/front-end/api/v1/agreementService/activity/modify/activity', // 【协定服务活动】- 修改协定服务活动名称
  activityPeopleList = '/front-end/api/v1/agreementService/activity/people/list', // 【协定服务活动】- 活动参与人列表
  addActivityPeople = '/front-end/api/v1/agreementService/activity/add/activity/people', // 【协定服务活动】- 添加活动参与人（单独）
  delActivityPeople = '/front-end/api/v1/agreementService/activity/audit/activity', // 协定服务活动】- 删除活动人员
  batchAddActivityPeople = '/front-end/api/v1/agreementService/activity/api/v1/import/activity/participants', // 【协定服务活动】- 导入活动人员
  downloadTemplate = '/front-end/api/v1/download/excel/template', // 【协定服务活动】- 下载导入模板
  downloadErrExcel = '/front-end/api/v1/agreementService/activity/api/v1/export/original/excel', // 【协定服务活动】- 下载原始上传的Excel文件
  cancelImport = '/front-end/api/v1/agreementService/activity/api/v1/import/activity/cancel', // 【协定服务活动】- 取消导入活动人员信息接口
  againSubmit = '/front-end/api/v1/agreementService/activity/api/v1/import/activity/again', // 【协定服务活动】- 重新提交活动人员导入数据
  activitySubmit = '/front-end/api/v1/agreementService/activity/submit/activity', // 【协定服务活动】- 提交活动
  activityDetail = '/front-end/api/v1/agreementService/activity/detail/activity', // 【协定服务活动】- 活动详情 (查看）
  uploadActivityFile = '/front-end/api/v1/agreementService/activity/upload/activity/attachment', // 【协定服务活动】- 上传活动附件

  exportTaskRecordList = '/front-end/task/api/v1/exportTaskRecordList', // 按照查询条件 导出任务记录

  summaryList = '/front-end/task/api/v1/summaryList', // 任务汇总列表
  exportRecordSummaryList = '/front-end/task/api/v1/exportRecordSummaryList', //任务汇总列表 --导出

  activityPeopleListExport = '/front-end/api/v1/agreementService/activity/people/list/export', //【协定服务活动】- 活动参与人列表导出

  selectSimilartList = '/front-end/vector/selectSimilartList', //图片查重
  getSimilarTaskDetail = '/front-end/vector/getSimilarTaskDetail' //图片查重 - 查看重复图片的详情
}
export const summaryList: SummaryList = params =>
  http.request({
    url: Api.summaryList,
    method: 'POST',
    params
  });
export const exportRecordSummaryList = (params: {
  req: any;
  projectId: number;
  selectedFieldNames: string[];
  sceneType: number;
}) =>
  http.download({
    url: Api.exportRecordSummaryList,
    method: 'POST',
    params
  });

export const activityPeopleListExport = (params: {
  projectId: number;
  activityId: number;
  userName?: string;
  phone?: string;
  settlementStatus?: string;
}) =>
  http.download({
    url: Api.activityPeopleListExport,
    method: 'POST',
    params
  });

export const exportTaskRecordList = params =>
  http.request({
    url: Api.exportTaskRecordList,
    method: 'POST',
    params
  });
export const taskRecordUpdateMap = async (params: {
  taskRecordId: number;
  projectId: number;
  sceneType: number;
}) =>
  http.request(
    {
      url: Api.taskRecordUpdateMap,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: true,
      successMessageText: '更新地图成功'
    }
  );
export const taskRecordPassIds = async (params: {
  projectId: number;
  sceneType: number;
  taskRecordId: number[];
}): Promise<
  Result<{
    sceneType: number;
    projectId: number;
    taskSum: number;
    checkPersonNum: number;
    personNum: number;
    personNames: string[];
    taskRecordId: number[];
  }>
> =>
  http.request({
    url: Api.taskRecordPassIds,
    method: 'POST',
    params
  });

export const userTags = async (params: {
  projectId: number;
}): Promise<
  Result<
    {
      label: string;
      value: string;
    }[]
  >
> =>
  http.request({
    url: Api.userTags,
    method: 'GET',
    params
  });

export const selectSimilartList = async (params: {
  projectId: number;
  taskIdList: number[];
}): Promise<
  Result<{
    [key in number]: number[];
  }>
> =>
  http.request({
    url: Api.selectSimilartList,
    method: 'POST',
    params
  });

export const getSimilarTaskDetail = async (params: {
  projectId: number;
  taskId: number;
  similarTaskIdList: number[];
}): GApiResult<{
  list: {
    taskId: number;
    createAt: string;
    userName: string;
    platformAuditStatus: number;
    aspAuditStatus: number;
    industryAuditStatus: number;
    isOverdue: number;
    taskCode: string;
    projectId: number;
  }[];
  total: number;
}> =>
  http.request({
    url: Api.getSimilarTaskDetail,
    method: 'POST',
    params
  });

export const locationMapComparison = async (params: {
  sceneType: number;
  projectId: number;
  taskRecordId: number;
  dataState: number;
}): Promise<
  Result<{
    customerName: string; //目标名称
    visitAddress: string; //目标地址
    ssq: string; //省市区
    addressWatermarkPicUrl: string; //拜访地点定位水印图片
    visitLongitude: string; //拜访经度
    visitLatitude: string; //拜访纬度
  }>
> =>
  http.request({
    url: Api.locationMapComparison,
    method: 'POST',
    params
  });

export const submitTask = async (params: {
  taskRecordId: number;
  projectId: number;
}) =>
  http.request({
    url: Api.submitTask,
    method: 'POST',
    params
  });

export const taskRecordStats = async (
  params: any
): Promise<
  Result<{
    supplierPending: number; //服务商待审核
    platformPending: number; //平台待审核
    approved: number; //审核通过
    rejected: number; //审核未通过（含服务商不通过和平台不通过）
  }>
> =>
  http.request({
    url: Api.taskRecordStats,
    method: 'POST',
    params
  });

export const getTaskRecordIds = async (params, from: 'quick' | 'task') => {
  const urlMap = {
    quick: Api.taskRecordIdsByQuick,
    task: Api.taskRecordIds
  };
  const url = urlMap[from];
  return await http.request({
    url,
    method: 'POST',
    params
  });
};

export const getProjectInfo = async (params: {
  projectId: number;
}): Promise<
  Result<{
    projectRequire: string; //项目要求
    isExcessAudit: number; //是否允许超量审核0否1是
    payPassagewayCode: string; //支付通道
    setTime: number; //可配置场景 是否配置时间题
    participantType: number; //参与方结构 1：工业-asp-p-c、2：工业-p-c、4：工业-asp-c、5：工业-c、；7：工业-运营基地-c、10：工业-asp-个体；11-工业-个体
  }>
> =>
  http.request({
    url: Api.projectInfo,
    method: 'GET',
    params
  });
export const taskRecordList: TaskRecordList = params =>
  http.request(
    {
      url: Api.taskRecordList,
      method: 'POST',
      params
    },
    {
      // yapi: 1263
    }
  );

export const getDisplayInfo = params =>
  http.request({
    url: Api.getDisplayInfo,
    method: 'POST',
    params
  });

export const taskRecordDetail = params =>
  http.request({
    url: Api.taskRecordDetail,
    method: 'POST',
    params
  });

export const quickAuditList = params =>
  http.request({
    url: Api.quickAuditList,
    method: 'POST',
    params
  });

export const batchAudit = async (params: {
  sceneType: number;
  taskRecordId: number[];
  auditStatus: number; //审核状态2审核通过3审核未通过
  remarks?: string; //不通过原因
  remarkType?: number; //备注是否需要提交 0 否 1是
  projectId: number;
}) =>
  http.request({
    url: Api.batchAudit,
    method: 'POST',
    params
  });

export const getOverdue = async (params: {
  sceneType: number;
  taskRecordId?: number[];
  createAtStart?: string; //创建时间开始
  createAtEnd?: string; //创建时间结束
}) =>
  http.request({
    url: Api.getOverdue,
    method: 'POST',
    params
  });

export const batchOverdue = async (params: {
  sceneType: number;
  taskRecordId?: number[];
  createAtStart?: string; //创建时间开始
  createAtEnd?: string; //创建时间结束
}) =>
  http.request({
    url: Api.batchOverdue,
    method: 'POST',
    params
  });

export const quickReplyList = async (params: {
  projectId: number | string;
}): Promise<
  Result<
    {
      id: number;
      content: string; // 审核快速回复内容
    }[]
  >
> =>
  http.request({
    url: Api.quickReplyList,
    method: 'POST',
    params
  });
export const deleteQuickReply = async (params: { id: number }) =>
  http.request({
    url: Api.deleteQuickReply + '/' + params.id,
    method: 'GET'
  });

export const auditRecordList: AuditRecordList = params =>
  http.request({
    url: Api.auditRecordList,
    method: 'POST',
    params
  });
export const setExcessAudit = async (params: {
  sceneType: number;
  projectId: number;
  excessAudit: number;
}) =>
  http.request({
    url: Api.setExcessAudit,
    method: 'POST',
    params
  });

export const selectMonthTask = async (params: {
  userId: number;
  projectId: number;
  month: string;
}): Promise<
  Result<{
    titleList: string[]; // 标题列表
    uvList: any[];
  }>
> =>
  http.request({
    url: Api.selectMonthTask,
    method: 'POST',
    params
  });

export const updatePrice = async (params: {
  projectId: number;
  taskRecordId: number;
  amount: number;
}) =>
  http.request({
    url: Api.updatePrice,
    method: 'POST',
    params
  });

export const addTaskNumList: AddTaskNumList = params =>
  http.request({
    url: Api.addTaskNumList,
    method: 'POST',
    params
  });
export const addTaskNumAjax = async (params: {
  taskNumVOList: {
    projectId: number;
    userId: number;
    taskNum: number;
  }[];
}) =>
  http.request({
    url: Api.addTaskNum,
    method: 'POST',
    params
  });
export const downloadTask = params =>
  http.download({
    url: Api.downloadTask,
    method: 'POST',
    params
  });

export const importSettlementAmountAjax = async (params: {
  file: File;
  projectId: number;
}) =>
  http.uploadFile({
    url: Api.importSettlementAmount,
    method: 'POST',
    params
  });

// 【协定服务活动】- 获取活动列表
export const activityList: ActivityList = params =>
  http.request({
    url: Api.activityList,
    method: 'POST',
    params
  });
export const createactivity = async (params: {
  projectId: number;
  activityName: string;
}) =>
  http.request({
    url: Api.createactivity,
    method: 'GET',
    params
  });

export const updateActivityName = async (params: {
  activityId: number;
  activityName: string;
}) =>
  http.request({
    url: Api.updateActivityName + '/' + params.activityId,
    method: 'GET',
    params: {
      activityName: params.activityName
    }
  });
export const delActivityPeople = async (params: {
  activityId: number;
  projectId: number;
  userId: number;
}) =>
  http.request({
    url: `${Api.delActivityPeople}/${params.activityId}/${params.projectId}/${params.userId}`,
    method: 'GET'
  });
export const activityPeopleList: ActivityPeopleList = params =>
  http.request({
    url: Api.activityPeopleList,
    method: 'POST',
    params
  });

export const addActivityPeople = async (params: {
  activityId: number;
  activityPeopleName: string; //活动人员姓名
  price: number; //结算金额
  phone: number; //手机号
  operator?: string; //经营者
}) =>
  http.request({
    url: Api.addActivityPeople,
    method: 'POST',
    params
  });

export const batchAddActivityPeople = async (params: {
  /**
   * {
    projectId: number;
    excelCode: string; //excel模板编码
    activityId: number; //协定服务活动id
    excelUploadUrl: string; //excel文件上传地址
    excelName: string; //导入excel文件名称
    importType?: number; //经营者导入方式 1：覆盖 2：新增
  }
   */
  inVO: string;
  file: File;
}) =>
  http.uploadFile({
    url: Api.batchAddActivityPeople,
    method: 'POST',
    params
  });

export const downloadTemplate = params =>
  http.download({
    url: Api.downloadTemplate + '/' + params.excelGroupCode,
    method: 'GET'
  });

export const downloadErrExcel = params =>
  http.download({
    url: Api.downloadErrExcel + '/' + params.excelCode,
    method: 'GET'
  });
export const cancelImport = params =>
  http.request({
    url: Api.cancelImport + '/' + params.excelCode,
    method: 'GET'
  });
export const againSubmit = async (params: {
  inVO: {
    projectId: number;
    excelCode: string; //excel模板编码
    activityId: number; //协定服务活动id
    excelUploadUrl: string; //excel文件上传地址
    excelName: string; //导入excel文件名称
    importType?: number; //经营者导入方式 1：覆盖 2：新增
  };
  dataList: any[];
}) =>
  http.request({
    url: Api.againSubmit,
    method: 'POST',
    params
  });
export const activitySubmit = async (params: { activityId: number }) =>
  http.request({
    url: Api.activitySubmit,
    method: 'POST',
    params
  });

export const activityDetail = async (params: { activityId: number }) =>
  http.request({
    url: Api.activityDetail + '/' + params.activityId,
    method: 'GET',
    params
  });
export const uploadActivityFile = async (params: {
  activityId: number;
  folderName: string;
  activityAttachmentInDTO: {
    activityId: number;
    fileName: string;
    fileUrl: string;
  }[];
}) =>
  http.request({
    url: Api.uploadActivityFile,
    method: 'POST',
    params
  });

export const uploadTaskFile = async (params: {
  projectId: number;
  taskRecordId: number;
  folderName: string;
  fileList: {
    fileNames: number;
    fileUrls: string;
  }[];
}) =>
  http.request({
    url: Api.uploadTaskFile,
    method: 'POST',
    params
  });

export const getTaskFile = async (params: {
  taskRecordId: number;
}): Promise<
  Result<{
    folderName: string;
    fileList: { fileName: string; fileUrl: string }[];
  }>
> =>
  http.request({
    url: Api.getTaskFile,
    method: 'POST',
    params
  });
